import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { competitionSchema, competitionListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/competitions/actions';
import { CompetitionsActionTypes as types } from 'app/ducks/competitions/types';

function* createCompetitionSaga(action): any {
  yield put(sagaActions.createCompetitionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).competitions.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, competitionSchema);

    yield put(sagaActions.createCompetitionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createCompetitionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateCompetitionSaga(action): any {
  yield put(sagaActions.updateCompetitionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).competitions.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, competitionSchema);

    yield put(sagaActions.updateCompetitionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateCompetitionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getCompetitionSaga(action): any {
  yield put(sagaActions.getCompetitionPending());
  const [error, response] = yield (yield TeammoApi(yield select())).competitions.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, competitionSchema);
    yield put(sagaActions.getCompetitionSuccess(normalizedResponse));
    return normalizedResponse.entities.competitions[normalizedResponse.result];
  }
  yield put(
    handleError(
      error,
      sagaActions.getCompetitionFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllCompetitionsSaga(action): any {
  yield put(
    sagaActions.getAllCompetitionsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.competitions.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield (yield TeammoApi(yield select()))).competitions.organisationList(
    action.payload.organisationId,
    paginationObject,
  );

  if (response) {
    // console.log(response);
    const normalizedResponse = normalize(response, competitionListSchema);

    yield put(
      sagaActions.getAllCompetitionsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllCompetitionsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createCompetitionSagaWatcher(): any {
  yield takeLatest(types.CREATE_COMPETITION_REQUESTED, createCompetitionSaga);
}

function* updateCompetitionSagaWatcher(): any {
  yield takeLatest(types.UPDATE_COMPETITION_REQUESTED, updateCompetitionSaga);
}

function* getCompetitionSagaWatcher(): any {
  yield takeLatest(types.GET_COMPETITION_REQUESTED, getCompetitionSaga);
}

function* getAllCompetitionsSagaWatcher(): any {
  yield takeEvery(
    types.GET_ALL_COMPETITIONS_REQUESTED,
    getAllCompetitionsSaga,
  );
}

export default function* root(): any {
  yield all([
    createCompetitionSagaWatcher(),
    updateCompetitionSagaWatcher(),
    getCompetitionSagaWatcher(),
    getAllCompetitionsSagaWatcher(),
  ]);
}
